import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getConsumerTypes = createAsyncThunk(
  '/getConsumerTypes',
  async () => {
    const response = await axios.get('/GetConsumerTypes');
    return response.data;
  }
);

export const getConsumerTypeDetails = createAsyncThunk(
  '/getConsumerTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetConsumerTypeDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const consumerTypeSlice = createSlice({
  name: 'consumerType',
  initialState: {
    loading: '',
    error: '',
    consumerTypes: [],
    consumerTypeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: '',
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.consumerTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },

  extraReducers: {
    [getConsumerTypes.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getConsumerTypes.fulfilled]: (state, action) => {
      state.consumerTypes = action.payload;
      state.loading = false;
    },
    [getConsumerTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getConsumerTypeDetails.fulfilled]: (state, action) => {
      state.consumerTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;

    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.consumerTypeDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const consumerTypeActions = consumerTypeSlice.actions;

export default consumerTypeSlice;
